import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as AnnouncementService from 'services/iam/announcement';

export const useAnnouncementService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createAnnouncement = async (data) => {
    const { error, payload } = await AnnouncementService.create({ data, token });
    if (error) {
      toast.error(error);
      return null;
    }

    toast.success('Announcement created successfully.');
    return payload;
  };

  const fetchAnnouncements = async (options = {}) => {
    const { error, payload } = await AnnouncementService.read({ ...options, token });
    if (error) {
      toast.error('Unable to fetch announcements at this time.');
      return { announcements: [], size: 0 };
    }

    const {
      data: announcements,
      meta: { size }
    } = payload;
    return { announcements, size };
  };

  const fetchAnnouncement = async (id, options = {}) => {
    const { error, payload } = await AnnouncementService.readById(id, { ...options, token });
    if (error) {
      toast.error('Unable to fetch announcement at this time.');
      return { announcement: null };
    }

    return { announcement: payload };
  };

  const updateAnnouncement = async (id, data) => {
    const { error } = await AnnouncementService.updateById(id, { data, token });
    if (error) {
      toast.error('Unable to update announcement at this time.');
      return false;
    }

    toast.success('Announcement updated successfully.');
    return true;
  };

  const deleteAnnouncement = async (id, options = {}) => {
    const { error } = await AnnouncementService.deleteById(id, { ...options, token });
    if (error) {
      toast.error('Unable to delete announcement at this time.');
      return false;
    }

    toast.success('Announcement deleted successfully.');
    return true;
  };

  return {
    createAnnouncement,
    fetchAnnouncements,
    fetchAnnouncement,
    updateAnnouncement,
    deleteAnnouncement
  };
};
